<template>
  <div class="contaner">
    <a-modal
      class="gufiiguy"
      title="报价详情"
      :visible="recordsVisible"
      @cancel="closeRecords"
      width="70%"
      @ok="addRecords"
    >
      <a-form-model
        :model="recordsForm"
        :rules="rules"
        ref="recordsForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <div class="title">
          <span>客户信息</span>
        </div>
        <div class="contanerCenter">
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="公司名称"
                prop="companyName"
              >
                <span>{{ recordsForm.companyName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="客户地址"
                prop="address"
              >
                <span>{{ recordsForm.address }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="客户联系人"
                prop="customerName"
              >
                <span>{{ recordsForm.customerName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="联系电话"
                prop="customerTelephone"
              >
                <span>{{ recordsForm.customerTelephone }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="固定电话"
                prop="fixedTelephone"
              >
                <span>{{ recordsForm.fixedTelephone }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="电子邮箱"
                prop="customerEmail"
              >
                <span>{{ recordsForm.customerEmail }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>报价信息(客户和明细)</span>
        </div>
        <div class="contanerCenter">
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="折扣"
                prop="discount"
              >
                <span>{{ recordsForm.discount }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="优惠价"
                prop="excludeTaxesPrice"
              >
                <span>{{ recordsForm.excludeTaxesPrice }}元</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="总计(不含税)"
                prop="totalPrice"
              >
                <span>{{ recordsForm.totalPrice }}元</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="评审费"
                prop="expertEvaluation"
              >
                <span>{{ recordsForm.expertEvaluation }}元</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="税金"
                prop="taxes"
              >
                <span>{{ recordsForm.taxes }}元</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="body">
            <a-table :data-source="detailList1" bordered :loading="loading" :pagination="false">
              <a-table-column key="subName" title="报价项目" ellipsis="true" data-index="subName" />
              <a-table-column key="testExpense" title="检测费(元)" ellipsis="true" data-index="testExpense" />
              <a-table-column
                key="reportFabrication"
                title="报告编制费(元)"
                ellipsis="true"
                data-index="reportFabrication"
              />
              <a-table-column
                key="expertEvaluation"
                title="专家评审费(元)"
                ellipsis="true"
                data-index="expertEvaluation"
              />
              <a-table-column key="total" title="合计(元)" ellipsis="true" data-index="total" />
              <a-table-column title="操作" width="180px">
                <template scope="text,record">
                  <a @click="details(record)">查看检测费用明细</a>
                </template>
              </a-table-column>
            </a-table>
          </div>
        </div>
        <div class="title">
          <span>其他信息</span>
        </div>
        <div class="contanerCenter">
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="商务联系人"
                prop="salesman"
              >
                <span>{{ recordsForm.salesman }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="电话"
                prop="telephone"
              >
                <span>{{ recordsForm.telephone }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="邮箱"
                prop="email"
              >
                <span>{{ recordsForm.email }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="商务联系人"
                prop="serviceName"
              >
                <span>{{ recordsForm.serviceName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="电话"
                prop="serviceTelephone"
              >
                <span>{{ recordsForm.serviceTelephone }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="邮箱"
                prop="serviceEmail"
              >
                <span>{{ recordsForm.serviceEmail }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="bottom">
          <div>
            1.此报价是根据贵司提供的信息和材料所报价格，如果最终检测和服务项目与此有出入，以实际产生服务内容为准，我司承诺结算时的单价不会高于本报价明细中单价。
          </div>
          <div>2.付款方式：合同签订7个工作日内支付50%，项目完成后7个工作日内付清；</div>
          <div>3.关于发票的说明：</div>
          <div>4.根据国家财务政策，对于增值税普通发票，从2019年11月1日起，我司将统一只提供电子版本增值税普通发票；</div>
          <div>5.增值税专用发票,税率为6%的技术服务费。</div>
        </div>
      </a-form-model>
      <template slot="footer">
        <div class="exportBottom">
          <div class="leftExport">
            <!-- <a-button type="primary" @click="fileExpott"> 
                         <a-icon v-if="typeIndex" type=""/>
                         <a-icon v-if="typeIndex" type=""/>
                         导出 
                    </a-button> -->
            <a-select v-model="expandIconPositionId" placeholder="导出" class="exportBox" allowClear>
              <!-- <a-select-option value="left">
                               <a-button type="primary" @click="fileExpott"></a-button>
                           </a-select-option> -->
              <a-select-option
                :value="item.id"
                v-for="(item, index) in expandIconPosition"
                :key="index"
                @click="changeExport(item.id)"
              >
                {{ item.title }}
              </a-select-option>
              <!-- <a-select-option value="item.id"  @click="export1">
                                {{item.title}} 
                           </a-select-option> -->
              <!-- <a-select-option value="right" @click="export2">
                               导出WORD 
                           </a-select-option>
                           <a-select-option value="right"  @click="export3">
                               导出合同PDF
                           </a-select-option>
                           <a-select-option value="right"  @click="export4">
                               导出合同WORD 
                           </a-select-option> -->
            </a-select>
          </div>
          <a-button key="back" @click="queryall"> 取消 </a-button>
        </div>
      </template>
      <!-- <div class="exportBox" v-if="typeIndex">
               <div>
                    <a-button  @click="export1" class="exp"> 导出PDF </a-button>
               </div>
               <div>
                    <a-button  @click="export2" class="exp"> 导出WORD </a-button>
               </div>
               <div>
                    <a-button  @click="export3" class="exp"> 导出合同PDF </a-button>
               </div>
               <div>
                    <a-button  @click="export4" class="exp"> 导出合同WORD </a-button>
               </div>
             </div> -->
    </a-modal>
    <RecordsDetails
      :type="type"
      :recordsDetailVisible="recordsDetailVisible"
      @closeVisible="closeVisible"
      :tableList="tableList"
    ></RecordsDetails>
  </div>
</template>

<script>
import RecordsDetails from './recordDetails.vue'
import {
  testDetails,
  itemsList,
  infoExport,
  exportContract,
  subCategoryDetail,
  getTestExpensesDetails,
  exprot
} from '@/api/Industry'
import { exportPrice, prePdf } from '@/api/surrounding'
import { resolveBlob } from '@/utils/index'
import axios_s from 'axios'
const exportJavaBaseUrl = process.env.VUE_APP_EXPORT_JAVA_BASE_URL

export default {
  components: {
    RecordsDetails,
  },
  props: ['recordsVisible', 'recordsForm', 'detailList1', 'recordsData'],
  data() {
    return {
      expandIconPositionId: undefined,
      expandIconPosition: [
        {
          id: 1,
          title: '导出PDF',
        },
        {
          id: 2,
          title: '导出WORD',
        },
        {
          id: 3,
          title: '导出合同PDF',
        },
        {
          id: 4,
          title: '导出合同WORD',
        },
      ],
      typeIndex: false,
      tableList: {},
      recordsForm: '',
      recordsDetailVisible: false,
      type: '',
      // detailList: [
      //     {
      //         //报价项目
      //         customerName: 1,
      //         //检测费
      //         testExpense: 1,
      //         // 报告编制费
      //         reportFabrication: 1,
      //         //专家评审费
      //         expertEvaluation: 1,
      //         //合计
      //         total: 2,

      //     }

      // ]
      // customerId: ''
      // recordsForm: []
      // recordsVisible: false
    }
  },
  methods: {
    changeExport(e) {
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeee')
      if (e == 1) {
        this.export1()
      } else if (e == 2) {
        this.export2()
      } else if (e == 3) {
        this.export3()
      } else if (e == 4) {
        this.export4()
      }
    },
    changwExport(e) {
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeee')
    },
    queryall() {
      this.recordsVisible = false
    },
    fileExpott() {
      this.typeIndex = !this.typeIndex
      console.log(this.typeIndex, 'this.typeIndex =============================')
    },
    export2() {
      exportPrice({
        id: this.recordsData.id,
        type: 1,
      }).then((res) => {
        if (res.code == 200) {
          exprot({
               path:res.data
          }).then(res1=> {
                window.open(res1)
          })
         

          // window.open(exportJavaBaseUrl + '/file/file/pre_pdf?path=' + res.data)
          //  window.open(res.data)
          this.typeIndex = !this.typeIndex
        } else {
          this.$message.error(res.msg)
        }
        console.log(res, 'res========================')
      })
      //      let arr3={...this.recordsData,...this.recordsForm};
      //      infoExport(arr3).then(res => {
      //           if(res.code == 200) {
      //                return new Promise((resolve, reject) => {
      //            axios({
      //      url: 'http://192.168.0.204:8888/utility/word/market_price',
      //      method: 'post',
      //      data: res,
      //    }).then((res1) => {
      //      resolve(res1.data)
      //      console.log(res1.data, 'res1.data==================')
      //      window.open('http://192.168.0.204:18937/' + res1.data)
      //    })
      //                })

      //           } else {
      //                this.$message.error(res.msg)
      //           }
      //      })
    },
    export1() {
      exportPrice({
        id: this.recordsData.id,
        type: 2,
      }).then((res) => {
        if (res.code == 200) {
         exprot({
               path:res.data
          }).then(res1=> {
                window.open(res1)
          })

          this.typeIndex = !this.typeIndex
        } else {
          this.$message.error(res.msg)
        }
        console.log(res, 'res========================')
      })
      //        let arr3={...this.recordsData,...this.recordsForm};
      //      infoExport(arr3).then(res => {
      //           if(res.code == 200) {
      //                return new Promise((resolve, reject) => {
      //            axios({
      //      url: 'http://192.168.0.204:8888/utility/pdf/market_price',
      //      method: 'post',
      //      data: res,
      //    }).then((res1) => {
      //      resolve(res1.data)
      //      console.log(res1.data, 'res1.data==================')
      //      window.open('http://192.168.0.204:18937/' + res1.data)
      //    })
      //                })

      //           } else {
      //                this.$message.error(res.msg)
      //           }
      //      })
    },
    export4() {
      exportContract({
        customerId: this.recordsData.customerId,
        companyName: this.recordsData.companyName,
        discountPrice: this.recordsData.discountPrice,
        projectName: this.recordsData.projectName,
        type: 1,
      }).then((res) => {
        if (res.code == 200) {
           exprot({
               path:res.data
          }).then(res1=> {
                window.open(res1)
          })
          // window.open(res.data)
          // axios_s.get(exportJavaBaseUrl + '/file/file/pre_pdf?path=' + res.data).then((res1) => {
          //   window.open(res1)
          // })
          // window.open(exportJavaBaseUrl + '/file/file/pre_pdf?path=' + res.data)
          this.typeIndex = !this.typeIndex
        } else {
          this.$message.error(res.msg)
        }
      })
      //      console.log('111111111111111')
      //      let arr3={...this.recordsData,...this.recordsForm};
      //      exportContract(arr3).then(res => {
      //           if(res.code == 200) {
      //                return new Promise((resolve, reject) => {
      //            axios({
      //      url: 'http://192.168.0.204:8888/utility/word/market_contract',
      //      method: 'post',
      //      data: res,
      //    }).then((res1) => {
      //      resolve(res1.data)
      //      console.log(res1.data, 'res1.data==================')
      //      window.open('http://192.168.0.204:18937/' + res1.data)
      //    })
      //                })

      //           } else {
      //                this.$message.error(res.msg)
      //           }
      //      })
    },
    export3() {
      exportContract({
        customerId: this.recordsData.customerId,
        companyName: this.recordsData.companyName,
        discountPrice: this.recordsData.discountPrice,
        projectName: this.recordsData.projectName,
        type: 2,
      }).then((res) => {
        if (res.code == 200) {
           exprot({
               path:res.data
          }).then(res1=> {
                window.open(res1)
          })
          // axios_s.get(exportJavaBaseUrl + '/file/file/pre_pdf?path=' + res.data).then((res1) => {
          //   window.open(res1)
          // })
          // window.open(res.data)
          // window.open(exportJavaBaseUrl + '/file/file/pre_pdf?path=' + res.data)
          this.typeIndex = !this.typeIndex
        } else {
          this.$message.error(res.msg)
        }
      })

      //    let arr3={...this.recordsData,...this.recordsForm};
      //           exportContract(arr3).then(res => {
      //                if(res.code == 200) {
      //                     return new Promise((resolve, reject) => {
      //                 axios({
      //           url: 'http://192.168.0.204:8888/utility/pdf/market_contract',
      //           method: 'post',
      //           data: res,
      //         }).then((res1) => {
      //           resolve(res1.data)
      //           console.log(res1.data, 'res1.data==================')
      //           window.open('http://192.168.0.204:18937/' + res1.data)
      //         })
      //                     })

      //                } else {
      //                     this.$message.error(res.msg)
      //                }
      //           })
    },
    //关闭检测费用明细明细弹窗
    closeVisible(data) {
      this.recordsDetailVisible = data
      console.log(this.recordsDetailVisible, ' this.recordsDetailVisible===================')
    },
    //查看检测费用明细明细
    details(record) {
      console.log(record, 'record===========================')
      //调用接口判断是那个项目
      subCategoryDetail(record.subId).then((res) => {
        if (res.code == 200) {
          this.type = res.data.parentId
          //获取检查费用明细
          getTestExpensesDetails({
            sheetId: record.sheetId,
            subId: record.subId,
          }).then((res) => {
            if (res.code == 200) {
              this.recordsDetailVisible = true
              this.tableList.list = res.data.list
              Object.assign(this.tableList, {
                companyName: this.recordsForm.companyName,
                subName: record.subName,
                total: record.testExpense,
              })
            } else {
              this.$message.error(res.msg)
            }
            console.log(this.tableList, 'res222222222222222222222222222')
          })
        }
        console.log(res, 'res==================')
      })
    },
    closeRecords() {
      this.recordsVisible = false
      this.$emit('changeRecords', this.recordsVisible)
    },
    addRecords() {
      this.recordsVisible = false
      this.$emit('changeRecords', this.recordsVisible)
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 16px;
  margin: 5px;
}
.contanerCenter {
  margin: 5px;
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 15px;
}
.bottom {
  margin-top: 20px;
  color: rgb(182, 179, 179);
}
.bottomBox {
  width: 100%;
  display: flex;
  align-content: space-between;

  margin: 10px;

  /* position: absolute;
    margin-right: 10px;
    margin-bottom: 10px; */
}
.expFile,
.exp {
  width: 150px;
}
.chooseType {
  position: relative;
  display: none;
  float: left;
  margin-top: 5px;
  z-index: 200;
}
/* .leftExport:hover
.exportBox {
     display:block;
            } */
/* .cancel {
     margin-left: 70% ;
     width: 150px;
            } */
.gufiiguy {
  position: relative;
}
.exportBottom {
  display: flex;
  justify-content: space-between;
}
/* .leftExport {
  margin-left: 0;
  background-color: rgb(19, 104, 231);

} */
.exportBox {
  width: 140px;
  text-align: center;
  background-color: rgb(19, 104, 231);
  border-radius: 15px;
  color: #fff;
  /* float: left;
     margin-top: 60px; */
  /* display: none; */
}
 

.leftExport .ant-select-selection {
     color: #fff;
  background-color: rgb(19, 104, 231) !important

}
/* .ant-select-selection { */
/* background-color: rgb(76, 146, 251); */
/* } */
</style>